module.exports = __webpack_public_path__ + "media/images/map-icons/pet_selected-885fcf1bf3079c64a4d34072fb4f508e.svg";